/**
 * src/gm/platform/storage.ts — localStorage 安全访问基座。
 * 引擎所有持久键（tp3:*）的统一读写入口；无 localStorage 的环境（Node 测试未注入
 * polyfill 时）安全降级返回 null，由调用层决定是报错还是跳过。
 *
 * 安全红线：本模块绝不接触 apikey 键（thirdplay:v2:* 归外壳）；写入内容不含 Key。
 */

export function safeStorage(): Storage | null {
  try {
    return typeof localStorage === 'undefined' ? null : localStorage
  } catch {
    return null
  }
}

export function readJson<T>(key: string): T | null {
  const s = safeStorage()
  if (!s) return null
  try {
    const raw = s.getItem(key)
    return raw ? (JSON.parse(raw) as T) : null
  } catch {
    return null
  }
}

/** 写 JSON；抛错原样上抛（配额超限由调用层映射为 STORAGE_FULL） */
export function writeJson(key: string, value: unknown): void {
  const s = safeStorage()
  if (!s) return
  s.setItem(key, JSON.stringify(value))
}

export function removeKey(key: string): void {
  const s = safeStorage()
  if (!s) return
  try {
    s.removeItem(key)
  } catch {
    // 忽略
  }
}

/** 按前缀列出全部键（清理项目会话/事件段用） */
export function listKeys(prefix: string): string[] {
  const s = safeStorage()
  if (!s) return []
  const out: string[] = []
  try {
    for (let i = 0; i < s.length; i++) {
      const k = s.key(i)
      if (k && k.startsWith(prefix)) out.push(k)
    }
  } catch {
    // 忽略
  }
  return out
}
